import React, { useEffect, useState } from 'react';
import {
  Create,
  SimpleForm,
  useDataProvider,
  useNotify,
  Toolbar,
  SaveButton,
} from 'react-admin';
import PackagesFormFields from '../customForms/PackagesFormFields';

const CustomToolbar = () => {
  const notify = useNotify();

  const onSuccess = (data) => {
    if (data?.message) {
      notify(data.message, { type: 'info' });
    } else {
      notify('Packages created.', { type: 'info' });
    }
  };

  return (
    <Toolbar>
      <SaveButton mutationOptions={{ onSuccess }} />
    </Toolbar>
  );
};

const PackagesCreate = () => {
  const dataProvider = useDataProvider();
  const [fileOptions, setFileOptions] = useState({ Pdfs: [], Images: [], Videos: [] });
  const [allRecyclings, setAllRecyclings] = useState([]);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const result = await dataProvider.listFiles();
        const allFiles = [...(result.Pdfs || []), ...(result.Images || []), ...(result.Videos || [])];

        setFileOptions({
          Pdfs: allFiles.filter(f => f.toLowerCase().endsWith('.pdf')),
          Videos: allFiles.filter(f => f.toLowerCase().endsWith('.mp4')),
          Images: allFiles.filter(f => !f.toLowerCase().endsWith('.pdf') && !f.toLowerCase().endsWith('.mp4')),
        });
      } catch (err) {
        console.error('Failed to fetch files', err);
      }
    };

    const fetchRecyclings = async () => {
      try {
        const recyclingsResponse = await dataProvider.getList('recyclings', {
          pagination: { page: 1, perPage: 100 },
          sort: { field: 'ID', order: 'ASC' },
          filter: {},
        });

        setAllRecyclings(recyclingsResponse.data || []);
      } catch (err) {
        console.error('Failed to fetch recyclings', err);
      }
    };

    fetchFiles();
    fetchRecyclings();
  }, [dataProvider]);

  return (
    <Create title="Nova Embalagem" redirect="edit">
      <SimpleForm toolbar={<CustomToolbar />}>
        <PackagesFormFields
          fileOptions={fileOptions}
          allRecyclings={allRecyclings}
        />
      </SimpleForm>
    </Create>
  );
};

export default PackagesCreate;
